<template>
    <b-modal ref="modal" centered hide-footer>
        <template #modal-header="{ close }">
            <h5 class="mb-0">¿Dónde comprar este producto?</h5>
            <button type="button" class="close close_modal_icon" @click="close()">
                <span aria-hidden="true"><i class="fas fa-times"></i></span>
            </button>
        </template>
        <ul class="list-unstyled">
            <li
                v-for="(distributor, i) in distributors"
                :key="i"
                class="mb-2"
            >
                <a
                    :href="'https://' + distributor.domain + '/products/' + encodeURIComponent(productSlug)"
                    target="_blank"
                    class="theme-btn-one btn-black-overlay btn_sm d-block text-center"
                >
                    {{ distributor.name }}
                </a>
            </li>
        </ul>
    </b-modal>
</template>

<script>
export default {
    name: 'DistributorModal',
    props: {
        distributors: {
            type: Array,
            default: () => []
        },
        productSlug: {
            type: String,
            required: true
        }
    },
    methods: {
        show () {
            this.$refs.modal.show()
        }
    }
}
</script>
